export default "__VITE_ASSET__CLVHnxJI__"